import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { DependencyLicenseListInitialState, DependencyLicenseListLoad } from './dependency-license-list.actions';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DependencyLicenseListService } from './dependency-license-list.service';
import { DependencyLicenseModel } from '../models';
import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants';
import { LIST_CLIENT_PAGINATION_INITIAL_STATE, ListClientPaginationStateModel } from '../../../../../common/models';

import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type DependencyLicenseListStateModel = ListClientPaginationStateModel<DependencyLicenseModel>;

const initialState: DependencyLicenseListStateModel = LIST_CLIENT_PAGINATION_INITIAL_STATE;

@State<DependencyLicenseListStateModel>({
  name: 'dependencyLicenseList',
  defaults: initialState,
})
@Injectable()
export class DependencyLicenseListState {
  constructor(
    public dependencyLicenseListService: DependencyLicenseListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  public static getState(state: DependencyLicenseListStateModel): DependencyLicenseListStateModel {
    return state;
  }

  @Selector()
  public static getLoaded(state: DependencyLicenseListStateModel): boolean {
    return state.loaded;
  }

  @Action(DependencyLicenseListLoad)
  getDependencyLicenses(
    ctx: StateContext<DependencyLicenseListStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.dependencyLicenseListService.getDependencyLicenseList().pipe(
      take(1),
      map((dependencyLicenseList: DependencyLicenseModel[]) => {
        ctx.patchState({ items: dependencyLicenseList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(DependencyLicenseListInitialState)
  setInitialState(ctx: StateContext<DependencyLicenseListStateModel>): void {
    ctx.setState(initialState);
  }
}
